<template>
  <div class="sciencePage">
    <div class="main-news-wrapper">
      <particlesJS class="particles" />
      <div class="inner" ref="inner">
        <transition-group name="fade" appear>
          <template v-for="(list, index) in latestNews" :key="index">
            <component
              :is="
                list.length === pageSize
                  ? `bar${index.toString().substr(-1)}`
                  : 'universalList '
              "
              :list="list"
              transition-mode="out-in"
            />
          </template>
        </transition-group>
      </div>
      <div
        v-if="show.spinner"
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 44px 0;
        "
        :style="{ height: latestNews.length > 0 ? 'unset' : '80vh' }"
      >
        <div class="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  computed,
  reactive,
  onMounted,
  onBeforeUnmount,
  watch
} from "vue";
import ParticlesJS from "@/components/science/ParticlesJS";
import AdditionalBar from "@/components/AdditionalBar";
import FirstBar from "@/components/science/FirstBar";
import SecondBar from "@/components/science/SecondBar";
import ThirdBar from "@/components/science/ThirdBar";
import FourthBar from "@/components/science/FourthBar";
import FivthBar from "@/components/science/FivthBar";
import { useStore } from "vuex";
import { useInfiniteScroll } from "@/utils/infiniteScroll";
import { useLanguage } from "@/utils/language";

export default {
  components: {
    ParticlesJS,

    universalList: AdditionalBar,

    bar0: FirstBar,
    bar1: SecondBar,
    bar2: ThirdBar,
    bar3: FourthBar,
    bar4: FivthBar,

    bar5: FirstBar,
    bar6: SecondBar,
    bar7: ThirdBar,
    bar8: FourthBar,
    bar9: FivthBar
  },
  setup() {
    const store = useStore();
    const inner = ref(null);
    const show = reactive({
      topBar: true,
      spinner: true
    });

    const { i18n } = useLanguage();

    const scrollEnd = () => {
      show.spinner = false;
    };

    const pageSize = 5;

    const { startInfiniteScroll, loadData } = useInfiniteScroll({
      wrapper: inner,
      retrieve: (load, cb) => {
        store.dispatch("getLatestNews", {
          pageSize,
          cb: () => cb(),
          category: 'science',
          load
        });
      },
      newsCount: computed(() => store.getters.newsCount),
      currentPage: computed(() => store.getters.currentPage),
      pageSize,
      scrollEnd
    });

    const checkWidth = () => {
      show.topBar = window.innerWidth >= 993;
    };

    var resizeTimeout;
    function resizeThrottler() {
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(function() {
          resizeTimeout = null;
          checkWidth();

          // The checkWidth will execute at a rate of 15fps
        }, 66);
      }
    }

    const refreshData = () => {
      store.commit("flushArticleState");

      show.spinner = true;
      startInfiniteScroll();
      loadData();
    };

    refreshData();

    watch(
      () => i18n.global.locale.value,
      () => refreshData()
    );

    onMounted(() => {
      window.addEventListener("resize", resizeThrottler, false);
      window.addEventListener("deviceorientation", resizeThrottler, true);
      resizeThrottler();
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", resizeThrottler);
      window.removeEventListener("deviceorientation", resizeThrottler);
    });

    return {
      inner,
      show,
      pageSize,
      latestNews: computed(() => store.getters.latestNews)
    };
  }
};
</script>

<style lang="scss" scoped>
.sciencePage {
  position: relative;
  height: auto;
  width: 100%;
  background-color: #777f9c;
  margin-bottom: 10rem;
  .main-news-wrapper {
    position: relative;
    --top-offset: calc(160px);
    margin: 0 auto;
    top: var(--top-offset);
    .first-Bar,
    .second-Bar,
    .third-Bar,
    .fourth-Bar,
    .fivth-Bar {
      pointer-events: none;
      :deep().card {
        pointer-events: all;
      }
    }
    @media screen and (max-width: 978px) {
      --top-offset: calc(100px);
    }
    @media screen and (max-width: 600px) {
      --top-offset: calc(70px);
    }
  }
  .particles {
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>
